module.exports = __webpack_public_path__ + "img/logo.363187c0.svg";